import { FC } from 'react';

// material-ui
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// third-party
import { HomeOutlined, ReloadOutlined, WarningOutlined } from '@ant-design/icons';

// project imports
import MainCard from '@/components/MainCard';
import { CodeBlock } from './code-block';

// ==============================|| ERRORS - FALLBACK (fatal render) ||============================== //

interface IErrorFallbackProps {
	name: string;
	message: string;
	stack: string;
	onRetry: () => void;
	onHome: () => void;
}

export const ErrorFallback: FC<IErrorFallbackProps> = ({
	name,
	message,
	stack,
	onRetry,
	onHome
}) => (
	<Stack
		sx={{ alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 2 }}
	>
		<MainCard sx={{ maxWidth: 760, width: '100%' }}>
			<Stack sx={{ gap: 2 }}>
				<Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
					<Box
						component="span"
						sx={{ color: 'warning.main', display: 'inline-flex', fontSize: '1.5rem' }}
					>
						<WarningOutlined />
					</Box>
					<Typography variant="h3" sx={{ flex: 1 }}>
						Eroare neașteptată
					</Typography>
					<Chip size="small" variant="light" color="warning" label="FE" />
				</Stack>

				<Alert severity="error" color="error">
					<AlertTitle>{name || 'Eroare FE'}</AlertTitle>
					{message}
				</Alert>

				{stack.trim() && (
					<Stack sx={{ gap: 0.5 }}>
						<Typography variant="caption" sx={{ color: 'text.secondary' }}>
							Stack trace
						</Typography>
						<CodeBlock>{stack}</CodeBlock>
					</Stack>
				)}

				<Stack direction="row" sx={{ gap: 1.5, justifyContent: 'flex-end' }}>
					<Button
						color="secondary"
						variant="outlined"
						startIcon={<HomeOutlined />}
						onClick={onHome}
					>
						Acasă
					</Button>
					<Button variant="contained" startIcon={<ReloadOutlined />} onClick={onRetry}>
						Reîncearcă
					</Button>
				</Stack>
			</Stack>
		</MainCard>
	</Stack>
);
